import { Router, } from "@angular/router";
// Third party packages
import { CookieService } from "ngx-cookie-service";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { ConfigService } from "src/app/shared/services/config.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../modules/auth/auth.service";
import * as i3 from "ngx-cookie-service";
import * as i4 from "../services/config.service";
/**
 * Route guard demanding EVERY permission listed in `data.permissions`.
 *
 * It exists beside `RoleGuard`, which checks the same key with an OR: some back-end
 * routes (the data types catalogue is one) are protected by `hasPerms([a, b])`, an AND,
 * and guarding them with the OR guard would let a user reach a page that answers 403 on
 * every single call.
 *
 * Same `data.permissions` key as RoleGuard on purpose, so that swapping one guard for
 * the other on a route is a one word change.
 *
 *   {
 *     path: 'data-types',
 *     component: DataTypesComponent,
 *     canActivate: [AllPermissionsGuard],
 *     data: { permissions: ['canReadDocumentsList', 'canCreateSettings'] },
 *   }
 *
 * @since 3.0.0
 */
var AllPermissionsGuard = /** @class */ (function () {
    /**
     * Class constructor
     */
    function AllPermissionsGuard(router, authService, cookieService, configService) {
        this.router = router;
        this.authService = authService;
        this.cookieService = cookieService;
        this.configService = configService;
    }
    /**
     * Let the route through only when the user is logged in AND the role currently
     * selected owns every requested permission.
     *
     * @since 3.0.0
     *
     * @returns true when allowed; false (plus a redirect) otherwise
     */
    AllPermissionsGuard.prototype.canActivate = function (route, state) {
        this.loggedUser = this.authService.loggedUser$.value;
        this.loggedUserPermissions = this.authService.loggedUserPermissions$.value;
        this.lang = this.cookieService.get("lang") || this.configService.defaultLang;
        // Re-check the session: an expired one goes back to the login page
        if (!this.loggedUser || !this.loggedUser._id) {
            this.router.navigate([this.lang, "auth", "login"], {
                queryParams: { returnUrl: state.url },
            });
            return false;
        }
        if (this.hasEveryPermission(route.data.permissions)) {
            return true;
        }
        this.router.navigate([this.lang, "errors", "400"]);
        return false;
    };
    /**
     * True when the current role owns EVERY requested permission. A route declaring no
     * permission is open, exactly like in RoleGuard.
     *
     * @since 3.0.0
     */
    AllPermissionsGuard.prototype.hasEveryPermission = function (requestedPermissions) {
        if (!requestedPermissions || !requestedPermissions.length) {
            return true;
        }
        var owned = this.loggedUserPermissions
            ? this.loggedUserPermissions
            : [];
        return requestedPermissions.every(function (perm) { return owned.indexOf(perm) >= 0; });
    };
    AllPermissionsGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AllPermissionsGuard_Factory() { return new AllPermissionsGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AuthService), i0.ɵɵinject(i3.CookieService), i0.ɵɵinject(i4.ConfigService)); }, token: AllPermissionsGuard, providedIn: "root" });
    return AllPermissionsGuard;
}());
export { AllPermissionsGuard };
